import { NgModule } from '@angular/core';
import { GlowAuthService } from './glowauth.service';
import { CacheService } from './cache.service';
import { DateFormatService } from '../date-format.service';
import { GlowAdminService } from './glowadmin.service';

@NgModule({
    declarations: [
    ],
    imports: [
    ],
    exports: [
    ],
    providers: [
        CacheService,
        DateFormatService,
        GlowAdminService, 
        GlowAuthService
    ]
})
export class GlowModule {
}
